import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-grafiek',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconGrafiek {

  render() {
    return (
      <svg viewBox="0 0 36.04 35.89" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M12 36H5c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1h7zm10 0h-8V17c0-.55.45-1 1-1h6c.55 0 1 .45 1 1zm9 0h-7V22h7c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1M22 0h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V3.41l-5.07 5.07a.996.996 0 0 1-1.41 0l-2.83-2.83-7.07 7.07a.996.996 0 1 1-1.41-1.41l7.74-7.74a.993.993 0 0 1 1.4-.01l2.82 2.73 4.41-4.3h-1.57c-.55 0-1-.45-1-1s.45-1 1-1Z"/>
</svg>

    );
  }
}
